import React from 'react'
import Helper from 'src/support/Helper';
import HCLDX from '@system/config/hcldx';
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';

const NavigateToPDP = (props) => {
  const { ManufacturerName = "", ERPMFRPartNumber = "", ItemNumber = "", searchTerm = "", isTypeHead } = props?.data;

  const getProductDetailPageRouteURLWithCustomParameter = () => {
    let newUrl = HCLDX.baseURL() + '/product';
    if (ManufacturerName) {
      newUrl += "/" + Helper.replaceSpecialChar(ManufacturerName?.toLowerCase());
    }
    if (ERPMFRPartNumber) {
      newUrl += "/" + Helper.replaceSpecialChar(ERPMFRPartNumber.toLowerCase())
    }
    if (ItemNumber) {
      newUrl += "/" + ItemNumber?.toLowerCase();
    }
    if (searchTerm) {
      newUrl += `?searchTerm=${searchTerm}`;
    } else {
      newUrl += "/"
    }
    return newUrl;
  }
  const typeHeadSearch = () => {
    if (isTypeHead) {
      HelperAnalyticsEvent.typeHeadSearchEvent(searchTerm, "Products", ERPMFRPartNumber, getProductDetailPageRouteURLWithCustomParameter())
    }
  }
   return (
    <>
      {Helper.valueIsNotNull(ItemNumber)
        &&
        (
          <>
            <a onClick={() => typeHeadSearch()} className={props?.class?props?.class:"cursor-pointer text-wrap text-break bs5 d-inline-block"}
              href={getProductDetailPageRouteURLWithCustomParameter()} target={props.target?props.target:'_self'}
            >
              {props.children}
            </a>
          </>
        )}
    </>
  );
}

export default NavigateToPDP
